/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsRecordingVersionItemsInner } from './RecordingManualChangesResponseFieldsRecordingVersionItemsInner';
import {
    RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSON,
    RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSONTyped,
    RecordingManualChangesResponseFieldsRecordingVersionItemsInnerToJSON,
} from './RecordingManualChangesResponseFieldsRecordingVersionItemsInner';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsRecordingVersion
 */
export interface RecordingManualChangesResponseFieldsRecordingVersion {
    /**
     * 
     * @type {Array<RecordingManualChangesResponseFieldsRecordingVersionItemsInner>}
     * @memberof RecordingManualChangesResponseFieldsRecordingVersion
     */
    items: Array<RecordingManualChangesResponseFieldsRecordingVersionItemsInner>;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsRecordingVersion interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsRecordingVersion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json: any): RecordingManualChangesResponseFieldsRecordingVersion {
    return RecordingManualChangesResponseFieldsRecordingVersionFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsRecordingVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsRecordingVersion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSON)),
    };
}

export function RecordingManualChangesResponseFieldsRecordingVersionToJSON(value?: RecordingManualChangesResponseFieldsRecordingVersion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(RecordingManualChangesResponseFieldsRecordingVersionItemsInnerToJSON)),
    };
}

